import {Selectable} from '../../../../core/interfaces/selectable.interface';

export class Owner implements Selectable<Owner> {
  constructor(
    public readonly id: number,
    public readonly name: string
  ) {
  }

  get value(): this {
    return this
  }

  get displayName(): string {
    return this.name;
  }

  toSelectText(): string {
    return this.name;
  }

  toSelectDescription(): string {
    return `Zaznaczono: ${this.name}`;
  }
}
